import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { forgotPasswordAction } from '../../../modules/auth/Actions';
import { authIsLoadingSelector } from '../../../modules/auth/Selectors';
import getLangData from '../../../utils/getLangData';

const Forgotpassword = props => {
  const { loginUser, isLoading = true, forgetPassword } = props;
  return (
    <Formik
      initialValues={{
        email: ''
      }}
      onSubmit={async values => {
        forgetPassword(values);
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => (
        <Form className='row fancy--login' onSubmit={handleSubmit}>
          <div
            className='left--section col-5 lazyload'
            data-bg='/assets/images/09.png'
            style={{
              background: 'url(/assets/images/09.png)',
              backgroundPosition: 'center',
              backgroundSize: 'cover'
            }}
          >
            <div className='inner'>
              <img className='logo' src='assets/images/favicons.png' alt='' />
              <div className='title'>
                <p className='small'>{getLangData().login.welcome_message}</p>
                <p>{getLangData().title} !</p>
              </div>
              <div className='links'>
                <ul>
                  <li>
                    <a href='#'>{getLangData().login.options.privacy}</a>
                  </li>
                  <li>
                    <a href='#'>{getLangData().login.options.legal}</a>
                  </li>
                  <li>
                    <a href='#'>{getLangData().login.options.contact}</a>
                  </li>
                </ul>
                <p>{getLangData().login.copy_right}</p>
              </div>
            </div>
          </div>
          <div className='right--section col-7'>
            <div className='form'>
              <h3>{getLangData().buttons.reset_password}</h3>
              <form action='#' className='custom--form'>
                <div className='input-group mb-3'>
                  <input
                    onChange={handleChange}
                    id='email'
                    name='email'
                    type='text'
                    // onkeyup="this.setAttribute('value', this.value);"
                    required
                  />
                  <label>{getLangData().fields.email}</label>
                </div>

                <div className='m-auto pt-4 submit'>
                  {/* <input type="submit"  className="btn btn-primary mb-4"   defaultValue="Sign In"/> */}
                  <button
                    disabled={isLoading}
                    type='submit'
                    className={`btn btn-primary mb-4 ${
                      isLoading ? `kt-spinner` : ``
                    }`}
                    style={{ width: '100%' }}
                  >
                    {isLoading ? (
                      <div style={{ margin: 'auto' }} class='loader'></div>
                    ) : (
                      getLangData().buttons.reset_password
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = state => {
  return {
    isLoading: authIsLoadingSelector(state)
  };
};

const mapDispatchToProps = {
  forgetPassword: forgotPasswordAction
};

export default connect(mapStateToProps, mapDispatchToProps)(Forgotpassword);
